import React, { useEffect, useState } from 'react';
import InputField from 'common/atoms/inputField/InputField';
import { useFeatureFlagsContext } from 'providers/featureflags-provider';
import MainImage from 'pages/wholeme/molecules/mainImage/MainImage';
import ProfileInputPage from 'pages/wholeme/molecules/inputPage/ProfileInputPage';
import { firstValueOf } from '../../../util/profile_util';
import appColor from '../../../../../common/app_colors';
import appStrings from '../../../../../common/app_strings';
import { useAppState } from '../../../../../providers/app-state/app-state-provider';

const { wholeMeAssets: { primary } } = appColor;
const { wholeMe: { wholeMeZipIntake } } = appStrings;

const ProfileIdentityIntakeZipPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => {
  const [zipState, setZipState] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const { platform } = useAppState();

  useEffect(() => {
    void (async () => {
    const state = await wholeMeClient.fetchZipState();
    setZipState(firstValueOf(state?.zip_code) || '');
  })();
  }, []);

  const { isSaveAndContinueAlwaysEnabled } = useFeatureFlagsContext() || {};

  const saveZip = () => {
    setErrorMessage('');
    wholeMeClient
      .saveZipState([
        {
          category_id: 'identity',
          question_id: 'zip_code',
          value: zipState,
        },
      ])
      .then((res) => {
        const { error } = res || {};
        if (error) setErrorMessage('Invalid Zip Code');
        else nextOnClick();
      });
  };

  const mainImageData = {
    imageSrc: './assets/icons/intake-pages/blue-hashtag-black-accents.svg',
    imageAlt: 'blue hashtag with black accents',
  };

  const isCtaDisabled = isSaveAndContinueAlwaysEnabled && zipState?.length !== 5;

  return (
    <ProfileInputPage
      paginationMeta={paginationMeta}
      nextOnClick={saveZip}
      prevOnClick={prevOnClick}
      wholeMeClient={wholeMeClient}
      isCtaDisabled={isCtaDisabled}
      title={wholeMeZipIntake.title}
      subtitle={wholeMeZipIntake.subtitle}
      backgroundOverlay="/assets/overlays/bottom-circle-right-circle-left-lines-overlay.svg"
      exitIconOnClickOverride={exitIconOnClickOverride}
      skipPersonalization={false}
    >
      <InputField
        onChange={(event) => setZipState(event.target.value)}
        placeholder="#####"
        fieldValue={zipState}
        icon="location"
        maxValueLength={5}
        enableNumpad
        theme="light"
        error={!!errorMessage && { message: errorMessage }}
        iconStyleOverride={{ color: primary }}
      />
      <MainImage
        imageSrc={mainImageData.imageSrc}
        imageAlt={mainImageData.imageAlt}
        imageStylesOverride={{
          width: platform?.isNativePlatform ? 'calc(90% - 80px)' : 'calc(45% - 80px)',
        }}
      />
    </ProfileInputPage>
  );
};

export default ProfileIdentityIntakeZipPage;
